import { type ReactElement } from 'react'
import { type TeamData } from '@terros/common'
import { useDisclosure } from '@mantine/hooks'
import { Divider, Stack } from '@mantine/core'
import { useTranslation } from '@front/model'
import { TeamEditFormPanel } from '../editTeam/TeamEditFormPanel'
import { TStack } from '../../TStack'
import { TSectionList, TDrawer } from '../../terros'
import { OptionalRow } from '../../OptionalRow'
import { EditEntitlements } from '../../entitlement'
import { useTeamDetailRows } from './useTeamDetailRows'
import { TeamAuditSection } from './TeamAuditSection'

type Props = {
  team: TeamData
}

export const TeamDetails = ({ team }: Props): ReactElement => {
  const { t } = useTranslation()
  const [isEditingTeam, { open: openTeamEditor, close: closeTeamEditor }] = useDisclosure(false)
  const rows = useTeamDetailRows({ team, onEditTeam: openTeamEditor })

  return (
    <Stack gap='xl'>
      <TSectionList heading={{ title: t('Details') }}>
        <TStack divider={<Divider />}>
          {rows.map((row) => (
            <OptionalRow key={row.label} {...row} />
          ))}
        </TStack>
      </TSectionList>
      <TeamAuditSection team={team} />
      <EditEntitlements entityId={team.teamId} readOnly={team.isDeleted} />
      <TDrawer
        isChildDrawer
        opened={isEditingTeam}
        size='lg'
        title={t('Edit {{name}}', { name: team.name })}
        onClose={closeTeamEditor}
      >
        <TeamEditFormPanel teamId={team.teamId} onSaved={closeTeamEditor} />
      </TDrawer>
    </Stack>
  )
}
